import { useMemo } from "react";
import MassFlow from "../../components/massFlow";
import { MassFlowConfig } from "../../components/massFlow/types";
import { interfaceMassColumns } from "../columns";
import { validateInterface } from "../validation";
import { downloadCsvTemplate, interfacesFromCsv } from "./csv";
import { emptyInterface, InterfaceFlow, INTERFACE_FIELDS } from "../types";

export interface MassInterfacesProps {
  interfaces: InterfaceFlow[];
  exportadorOptions: string[];
  search: string;
  onSearchChange: (value: string) => void;
  onBack: () => void;
  onSaved: () => Promise<void> | void;
}

export default function MassInterfaces(props: MassInterfacesProps) {
  const {
    interfaces,
    exportadorOptions,
    search,
    onSearchChange,
    onBack,
    onSaved,
  } = props;

  const config = useMemo<MassFlowConfig>(
    () => ({
      tableId: "interfacesMassFlow",
      endpoint: "/easyFlow2.0/interfaces",
      entity: {
        singular: "interface",
        plural: "interfaces",
        gender: "f",
      },
      searchPlaceholder: "Pesquisar interfaces",
      fields: INTERFACE_FIELDS,
      emptyValues: emptyInterface,
      columns: interfaceMassColumns(exportadorOptions),
      validate: validateInterface,
      csv: {
        onDownloadTemplate: downloadCsvTemplate,
        parse: interfacesFromCsv,
      },
    }),
    [exportadorOptions],
  );

  return (
    <MassFlow
      config={config}
      records={interfaces}
      search={search}
      onSearchChange={onSearchChange}
      onBack={onBack}
      onSaved={onSaved}
    />
  );
}
